import { cn } from "@/lib/utils"
import * as React from "react"

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
    error?: string
    ariaLabel: string
}

export const TextField = React.forwardRef<HTMLInputElement, Props>(function TextField(
    { error, className, ariaLabel, ...props },
    ref
) {
    return (
        <div className="space-y-2">
            <div
                className={cn(
                    [
                        "rounded-2xl bg-soft shadow-(--shadow-sm)",
                        "transition-[box-shadow,background-color] duration-200",
                        "focus-within:bg-white focus-within:shadow-(--shadow-md)",
                    ].join(" "),
                    error ? "ring-2 ring-[color-mix(in_oklab,var(--color-accent-2),transparent_55%)]" : ""
                )}
            >
                <input
                    ref={ref}
                    aria-label={ariaLabel}
                    className={cn(
                        [
                            "w-full bg-transparent px-4 py-3.5 text-sm text-text",
                            "placeholder:text-[color-mix(in_oklab,var(--color-text),transparent_58%)]",
                            "transition-[color] duration-200",
                            "autofill:shadow-[inset_0_0_0_1000px_white]",
                        ].join(" "),
                        className
                    )}
                    {...props}
                />
            </div>

            {error ? (
                <p className="text-xs text-[color-mix(in_oklab,var(--color-accent-2),black_18%)]">
                    {error}
                </p>
            ) : null}
        </div>
    )
})